(function () {
  if (window.__erosShellPredictiveDismissBound) return;
  window.__erosShellPredictiveDismissBound = true;

  var ROOT_LOCALE_PATH = /^\/[a-z]{2}(-[A-Z]{2})?\/?$/;

  function isHomePath(pathname) {
    return pathname === '/' || ROOT_LOCALE_PATH.test(pathname);
  }

  function getPredictiveElements() {
    // ADR-177: no longer a <predictive-search> custom element (see
    // eros-hybrid-search.js) — match by class only.
    return Array.prototype.slice.call(
      document.querySelectorAll('.eros-shell-search-bar__predictive')
    );
  }

  function getResultsSlot(predictive) {
    return predictive.querySelector('[slot="results"]');
  }

  function hasResults(predictive) {
    var slot = getResultsSlot(predictive);
    return !!(slot && slot.innerHTML.trim() !== '');
  }

  function clearPredictiveResults(predictive) {
    var slot = getResultsSlot(predictive);
    if (slot) slot.innerHTML = '';
  }

  function isClickInsidePredictiveZone(target, predictive) {
    if (predictive.contains(target)) return true;

    var id = predictive.id;
    if (id) {
      var form = document.querySelector('[aria-owns="' + id + '"]');
      if (form && form.contains(target)) return true;
    }

    var searchRow = document.querySelector('.eros-shell-search-bar-row');
    if (searchRow && searchRow.contains(target)) return true;

    return false;
  }

  document.addEventListener(
    'click',
    function (event) {
      getPredictiveElements().forEach(function (predictive) {
        if (!hasResults(predictive)) return;
        if (isClickInsidePredictiveZone(event.target, predictive)) return;
        clearPredictiveResults(predictive);
      });
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    var cleared = false;
    getPredictiveElements().forEach(function (predictive) {
      if (!hasResults(predictive)) return;
      clearPredictiveResults(predictive);
      cleared = true;
    });

    if (cleared) {
      var input = document.querySelector('.eros-shell-search-bar__input');
      if (input && document.activeElement === input) input.blur();
    }
  });

  var backLi = document.querySelector('[data-eros-history-back]');
  if (backLi) {
    var backBtn = backLi.querySelector('button');

    function updateBackVisibility() {
      var show = window.history.length > 1 && !isHomePath(window.location.pathname);
      backLi.hidden = !show;
    }

    updateBackVisibility();

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        window.history.back();
      });
    }

    window.addEventListener('popstate', updateBackVisibility);
  }
})();
